import React from 'react'
import Bannervideolist from './../../components/atoms/BannerHeader'
import { withStyles } from '@material-ui/core/styles'

const styles = themes => ({
    root: {
    display: 'none'
  },
})

const BasePage = ({ classes }) => (
  <div className={classes.root}>
    <Bannervideolist />
  </div>
)

export default withStyles(styles)(BasePage)
